import {
  Button,
  CircularProgress,
  Divider,
  Grid,
  Paper,
  TextField,
  Typography,
} from "@material-ui/core";
import React, { useState } from "react";
import placeholder from "assets/imgs/placeholder-img.jpg";
import icon from "assets/imgs/icon.png";

import { isImage, newId, getExtension } from "utils/Utils.js";
import Firebase from "Firebase.js";

export default function CriarQuadro() {
  const [image, setImage] = useState(null);
  const [nome, setNome] = useState("");
  const [descricao, setDescricao] = useState("");

  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (nome && image && descricao) {
      if (isImage(image.name)) {
        setLoading(true);
        const id = newId();
        const filename = id + "." + getExtension(image.name);
        let resStorage = await Firebase.fire
          .storage()
          .ref("quadros/" + filename)
          .put(image);
        const imageUrl = await resStorage.ref.getDownloadURL();
        await Firebase.fire.firestore().collection("quadros").doc(id).set({
          id: id,
          nome: nome,
          descricao: descricao,
          imageFile: filename,
          imageUrl: imageUrl,

          createdAt: Date.now(),
        });
        setLoading(false);
        alert("Quadro criado com sucesso!");
        setNome("");
        setImage(null);
        setDescricao("");
      } else {
        alert("O arquivo deve ser uma imagem.");
      }
    } else {
      alert("Preencha todos os campos.");
    }
  };

  const handleImageChange = (e) => {
    setImage(e.target.files[0]);
  };

  const handleNomeChange = (e) => {
    setNome(e.target.value);
  };

  const handleDescChange = (e) => {
    setDescricao(e.target.value);
  };

  return (
    <div>
      <Grid
        container
        alignItems="center"
        justifyContent="center"
        spacing={3}
        style={{ padding: "15px", textAlign: "center" }}
      >
        <Grid item xs={12} style={{ marginBottom: "15px" }}>
          <img src={icon} height="100px" />
          <Typography variant="h3">Criar Quadro</Typography>
          <Divider />
        </Grid>

        <Grid item xs={10} style={{ textAlign: "center" }}>
          <form onSubmit={submit}>
            <Paper elevation={3} style={{ paddingTop: "15px" }}>
              <img
                src={image ? URL.createObjectURL(image) : placeholder}
                height="200px"
                width="200px"
                style={{ borderRadius: "1000px" }}
              />
              <br />
              <TextField type="file" onChange={handleImageChange} />
              <Divider style={{ margin: "15px" }} />
              <Grid container alignItems="center" justifyContent="center">
                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Nome do Quadro"
                    type="text"
                    autoFocus
                    value={nome}
                    onChange={handleNomeChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    placeholder="Descrição"
                    type="text"
                    multiline
                    minRows={3}
                    maxRows={6}
                    color="secondary"
                    value={descricao}
                    onChange={handleDescChange}
                  />
                </Grid>

                <Grid item xs={8} style={{ paddingBottom: "10px" }}>
                  <Button
                    type="submit"
                    fullWidth
                    variant="contained"
                    disabled={loading}
                  >
                    {!loading ? "Enviar" : <CircularProgress color="primary" />}
                  </Button>
                </Grid>
              </Grid>
            </Paper>
          </form>
        </Grid>
      </Grid>
    </div>
  );
}
